import { Outlet } from 'react-router-dom';
import Navbar from '../navbar/Navbar';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import '../layout/layout.css';

// Redux.
import { selectProgress } from '../../redux/reducers/progress.Slice';
import { useSelector } from "react-redux";

const Layout = () => {
  const progress = useSelector(selectProgress)

  return <div className='content' id='content'>
    <Navbar />
    <Outlet />
    
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={progress}
    >
      <CircularProgress color="inherit" />
    </Backdrop>    
  </div>;
};

export default Layout;